/* Display-only translations for ten approved reviews. Judge.me originals stay intact. */
(() => {
  const config = document.getElementById('ck-linkoo-review-translations');
  if (!config) return;
  const translations = JSON.parse(config.textContent);
  const selector = ':is(#judgeme_product_reviews, #linkoo-original-product-reviews)';
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(update);
  });
  function update() {
    pending = false;
    observer.disconnect();
    document.querySelectorAll(`${selector} .jdgm-rev[data-review-id]`).forEach(review => {
      const translation = translations[review.dataset.reviewId];
      if (!translation) return;
      const title = review.querySelector('.jdgm-rev__title');
      const body = review.querySelector('.jdgm-rev__body');
      if (title && title.textContent !== translation.title) title.textContent = translation.title;
      if (body && body.textContent !== translation.body.join('')) {
        body.replaceChildren(...translation.body.map(text => {
          const p = document.createElement('p');
          p.textContent = text;
          return p;
        }));
        body.lang = 'ja';
      }
      review.dataset.ckTranslated = 'ja';
    });
    const root = document.querySelector(selector);
    observer.observe(root || document.body, { childList: true, subtree: true, characterData: true });
  }
  update();
})();
